<template>
	<!-- App -->
	<!-- <f7-page class="" id="contacts"> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="showSmallScreenOnly" v-bind:class="colorBottomButton">
      <f7-fab class="leftfav4 button-fab bottomButton floatingButtonToolbarBlank" @click="OpenFormsPage">
        <f7-icon f7="add"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav3 button-fab bottomButton floatingButtonToolbarBlank" @click="OpenFormsImportPage">
          <f7-icon f7="list_bullet"></f7-icon>
         <span class="showLargeScreenOnly fab-label">{{ $t('bank_accounts.add_bank_account') }}</span>
      </f7-fab>
      <f7-fab class="leftfav2 button-fab bottomButton floatingButtonToolbarBlank" @click="OpenFormListStatement">
        <f7-icon f7="money_euro"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank" @click="extractCSV()">
        <f7-icon f7="document_text"></f7-icon>
      </f7-fab>
    </div>
    <div class="page-content">

  		<page-nav-bar
        currentServiceName="MoneyRoad"
        popoverName=".popoverBanks"
        :subNavTitle="$i18n.t('common.item_list',
                      {itemname: $t('leftPanelTitle.bk_accts')})"
        :menuAccess="true">
      </page-nav-bar>

      <div class="row rowBackgroundImage showLargeScreenOnly" v-bind:class="colorBottomButton">
        <div class="row rowSearchBar">
          <div class="firstButtonMarginLeft">
            <button class="new-button milkyBlock boxRequest" @click="OpenFormsPage">
                <f7-icon f7="add"></f7-icon>
                <span>{{ $t('bank_accounts.add_bank_account') }}</span>
            </button>
          </div>
          <button class="new-button milkyBlock boxRequest" @click="OpenFormsImportPage">
              <f7-icon f7="list_bullet"></f7-icon>
              <span>{{ $t('bank_accounts.imprt_bank_account') }}</span>
          </button>
          <button class="new-button milkyBlock boxRequest" @click="OpenFormListStatement">
              <f7-icon f7="money_euro"></f7-icon>
              <span>{{ $t('bank_accounts.view_statements') }}</span>
          </button>
          <button class="new-button milkyBlock boxRequest" @click="extractCSV()">
            <f7-icon f7="document_text"></f7-icon>
            <span>{{ $t('common.extract_csv') }}</span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div id="containerCSV" style="display:none;"></div>
      		<f7-searchbar class="search"
      			id="searchBankAccount"
      			cancel-link="Cancel"
      			search-list="#bank-list"
      			placeholder="Search in Accounts"
            @searchbar:search="onSearch"
            @searchbar:clear="onClear">
      		</f7-searchbar>
        </div>
      </div>
  		<div class="layoutSubtitle"/>

  		<!--<f7-list class="searchbar-found" id="search-list">-->
  		<cm-bank-accounts-list :bankAccounts="bankAccounts" :filterBy="filterBy"></cm-bank-accounts-list>
      <cm-pagination
        :firstIndex="paginationObject.firstIndex"
        :maxResultsByPage="paginationObject.maxResults"
        :nbResultsTotal="paginationObject.nbResultsTotal"
        :refreshEvent="paginationObject.refresh"
        >
      </cm-pagination>
      <!--</f7-list>-->
      <f7-list class="searchbar-not-found">
        <f7-list-item title="Nothing found"></f7-list-item>
      </f7-list>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
	<!-- </f7-page> -->
</template>

<script>
import BankAccountsList from './CMBankAccountsPage/CMBankAccountsList.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import moment from 'moment'
import pagination from '@/components/common/pagination.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'BankAccounts',
  components: {
    'cm-bank-accounts-list': BankAccountsList,
    'page-nav-bar': pageNavBar,
    'cm-pagination': pagination,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      bankAccounts: [],
      filterBy: '',
      service: '',
      paginationObject: {}
    }
  },
  created () {
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 10
    this.paginationObject['nbResultsTotal'] = 0
    this.paginationObject['refresh'] = 'refresh-bank-accounts'
    /* Turn off all buses events */
    // this.$bus.$off('inbox-filtered')
    this.$bus.$off('sendbox-filtered')
    // this.$bus.$off('refresh-cache-service')
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    // this.$bus.$off('refresh-cache-attachments-view')
    this.$bus.$off('refresh-cache-attachments')
    this.$bus.$off('refresh-cache-account-members')
    this.$bus.$off('refresh-inbox-list-cache')
    this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage
    this.$bus.$off('refresh-bank-accounts')
    this.$bus.on('refresh-bank-accounts', (index = 1) => {
      this.getBankAccounts(index)
    })
    this.getBankAccounts()
    this.service = this.$engine.user.currentService.name
  },
  methods: {
    getBankAccounts: function (index = 1) {
      // this.bankAccounts = this.$engine.bankAccounts.get()
      this.paginationObject.firstIndex = index
      let params = {
        // firstIndex: this.paginationObject.firstIndex,
        // maxResults: this.paginationObject.maxResults,
        idAccount: this.$engine.user.get().id
      }
      // this.bankAccounts = this.$engine.bankAccounts.get()
      this.$engine.bankAccounts.getParams(params).then(response => {
        this.organiserResponse(response)
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    },
    organiserResponse: function (response) {
      var bankAccountsList = []
      let bankAccountsReturn = response.data.bankAccounts
      let nbElement = 0
      this.paginationObject.nbResults = 0
      for (var j = 0; j < bankAccountsReturn.length; j++) {
        if (bankAccountsReturn[j].name.toLowerCase().includes(this.filterBy.toLowerCase())) {
          nbElement++
          if (this.paginationObject.firstIndex <= nbElement && nbElement < (this.paginationObject.firstIndex + this.paginationObject.maxResults)) {
            this.paginationObject.nbResults++
            bankAccountsList.push(bankAccountsReturn[j])
          }
        }
      }
      this.paginationObject.nbResultsTotal = nbElement
      this.bankAccounts = bankAccountsList
      // this.$bus.on => src\components\common\pagination.vue
      this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
    },
    onSearch: function (query, found) {
      this.filterBy = query
      this.getBankAccounts()
    },
    onClear: function () {
      this.filterBy = ''
    },
    OpenFormsPage () {
      loadPage(this, {url: '/bankAccounts/create/'})
    },
    OpenFormsImportPage () {
      loadPage(this, {url: '/bankAccounts/import/'})
    },
    OpenFormListStatement () {
      this.$engine.bankAccounts.setImportReport('')
      this.$engine.bankAccounts.setIbanStatment('')
      loadPage(this, {url: '/bankAccounts/listStatement/'})
    },
    extractCSV () {
      let params = {
        firstIndex: 1,
        maxResults: this.paginationObject.nbResultsTotal,
        idAccount: this.$engine.user.get().id
      }
      // this.bankAccounts = this.$engine.bankAccounts.get()
      this.$engine.bankAccounts.getParams(params).then(response => {
        let firstLine = 'id;name;Iban\r\n'
        let lines = ''
        let bankAccounts = response.data.bankAccounts
        for (var account in bankAccounts) {
          lines += bankAccounts[account].id + ';' + bankAccounts[account].name + ';' +
          BankAccountsList.methods.formatIban(bankAccounts[account].iban, bankAccounts[account].zoneCode) + '\r\n'
        }

        let data = firstLine + lines
        let today = moment()
        // encode 64 résoud le pb du retour à la ligne sur Firefox.
        var linkSource = 'data:text/csv;charset=utf-8;base64,' + btoa(data)

        const downloadLink = document.createElement('a')
        var fileName = ''
        if (this.service === 'Direct Debit') {
          fileName = 'bankAccountModularLoan' + today.unix() + '.csv'
        } else if (this.service === 'Direct Payments') {
          fileName = 'bankAccountDirectPayments' + today.unix() + '.csv'
        } else {
          fileName = 'bankAccountRequestToPay' + today.unix() + '.csv'
        }

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    }
  }
}
</script>


<style scoped>
/* .AddBankAccount {
	width: 98%;
} */
/* .EditBankAccount {
	width: 98%;
} */
@media (max-width: 768px) {
  .search {
    margin-top: 42px;
  }
  .toolbarPageBottomBlank {
    height: 175px !important;
  }
}

@media (min-width: 768px) and (max-width: 996px) {
  .search {
    margin-top: 35px;
  }
}
.col-md {
  margin-right: 0%;
}
@media (max-width: 768px) {
  .toolbarPageBottomBlank {
    height: 175px;
  }
}
.rowBackgroundImage {
  background-image: url('../../assets/static/images/MenuFont.png');
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// CMBankAccountsPage.vue?07d273f8